import { useTranslation } from "react-i18next";

import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { DeviceProductCard } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/DeviceProductCard.tsx";
import { getIconForProductCategory } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/ProductCategoryIcon.tsx";
import { SimStatusChip } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/SimStatusChip.tsx";
import { ExtendedSimCardDetail } from "@/hooks/useExtendedSims.ts";
import { useGetTitle } from "@/hooks/useGetTitle.ts";
import { getFlatNameFromDevice } from "@/utils/deviceUtils";

interface SuspendedSimTileProps {
  device: ExtendedSimCardDetail;
  manageRoute: string;
}

export const SuspendedSimTile = ({ device }: SuspendedSimTileProps) => {
  const { t } = useTranslation("portal");
  const icon = getIconForProductCategory(device);
  const title = useGetTitle(device.alias);

  return (
    <DeviceProductCard
      dataTestid="suspended-sim"
      icon={icon}
      title={title}
      subtitle={getFlatNameFromDevice(device)}
      chips={<SimStatusChip status={device.simStatus} />}
      footer={
        <ProductCardFooterItem
          variant="notification"
          tone="error"
          title={t("layout.tiles.suspendedSim.yourSimSuspended")}
        />
      }
    />
  );
};
